export const API_ENDPOINTS = {
  auth: {
    login: "/auth/login",
    logout: "/auth/logout",
  },
  organisation: {
    details: "/organisation",
    terms: "/terms",
  },
  projects: {
    forDonation: "/projectsforDonation",
    activatedPaymentGateway: id => `/getActivatedPG/${id}`,
  },
  donations: {
    create: "/makeDonation",
    list: (uniqid, count) => `/donationview/${uniqid}/${count}`,
    detail: uniqid => `/donationview/${uniqid}`,
    donorView: uniqid => `/donarDonationview/${uniqid}`,
    paymentStatus: uniqid => `/paymentStatus/${uniqid}`,
    modeSwitch: id => `/modeSwitch/${id}`,
  },
  payment: {
    create: "/payments",
    status: (uniqid, pgId) => `/paymentStatus/${uniqid}/${pgId}`,
  },
  receipts: {
    generate: "/receiptGenerate",
    check: uniqid => `/checkReceipt/${uniqid}`,
    userReceiptEmail: uniqid => `/userReceiptEmail/${uniqid}`,
    userReceipt: uniqid => `/userGetReceipt/${uniqid}`,
    userReceiptBase: "/userGetReceipt",
    selfDeclaration: uniqid => `/getSelfDeclaration/${uniqid}`,
    selfDeclarationBase: "/getSelfDeclaration",
    adminReceiptEmail: uniqid => `/receiptEmail/${uniqid}`,
  },
  reports: {
    donationReports: "/donationReports",
  },
};
